import Home from 'in-meeting-experience-ui-components/components/home/Home/Home';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { repeatedVisitKey, routes, unauthorizedRoutesParam } from '../constants/routes';
import { fetchUserInfo } from '../data/api/authApi';
import useTracker from '../hooks/useTracker';
import { callObjectTitleSelector } from '../slices/callObject/selectors';
import { meetingIdSelector } from '../slices/google/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function HomePage() {
  const meetingId = useSelector(meetingIdSelector);
  const callObjectTitle = useSelector(callObjectTitleSelector);
  const usageTracker = useTracker();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "HOME_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Home, {
      accountsRoute: routes.accounts,
      unauthorizedRoutesParam: unauthorizedRoutesParam,
      meetingContext: {
        meetingTopic: callObjectTitle || 'Google Meet',
        meetingID: meetingId
      },
      isLoading: false,
      usageTracker: usageTracker,
      repeatedVisitKey: repeatedVisitKey,
      fetchUserInfo: fetchUserInfo
    })
  });
}
export default HomePage;